import {ExclamationCircleFilled, InfoCircleOutlined} from '@ant-design/icons'
import {App, Button, Form, Input, message, Modal, Select} from 'antd'
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useNavigate, useRevalidator, useRouteLoaderData} from 'react-router-dom'
import {useCurrentUser} from '../../hooks/useCurrentUser'
import {
  instance as userService,
  MetricSystem,
  MetricSystemMetadata,
  UserSettings,
} from '../../services/UserService'

const {confirm} = Modal

export function UserPage() {
  const intl = useIntl()
  //const [form] = Form.useForm()
  const [isSubmitting, setSubmitting] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  const revalidator = useRevalidator()
  const navigate = useNavigate()

  const {userSettings} = useRouteLoaderData('user') as {
    userSettings: UserSettings
  }

  const [isEmailSent, setEmailSent] = useState(false)

  const app = App.useApp()

  const showConfirm = () => {
    app.modal.confirm({
      title: intl.formatMessage({id: 'doYouReallyWantToDeleteThisAccount'}),
      icon: <ExclamationCircleFilled />,
      content: intl.formatMessage({id: 'yourActionsCannotBeUndone'}),
      async onOk() {
        const result = await userService.deleteCurrentUser()
        if (result.success) {
          //document.cookie = 'supabase-auth-token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
          navigate('/')
        }
      },
    })
  }

  // useEffect(() => {
  //   form.setFieldsValue(userSettings)
  // }, [userSettings])

  const user = useCurrentUser()

  if (!user) {
    return null
  }

  return (
    <div>
      <div style={{marginBottom: 40}}>
        <h2>{intl.formatMessage({id: 'userSettings'})}</h2>
      </div>
      <div>
        <span>{intl.formatMessage({id: 'userEmail'})}: </span>
        <span style={{fontStyle: 'italic'}}>{userSettings.email}</span>
      </div>
      {/* <Form
        form={form}
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap
        layout="horizontal"
        style={{maxWidth: 700}}
        onFinish={async (formState) => {
          setSubmitting(true)
          let result: {success: boolean; error?: string}
          const user: UserSettings = {
            userName: formState.userName,
            metricSystem: formState.metricSystem,
          }

          result = await userService.changeUserSettings(user)

          setSubmitting(false)
          if (result.success) {
            revalidator.revalidate()
          } else {
            messageApi.open({
              type: 'error',
              content: result.error,
            })
          }
        }}
      >
        <Form.Item
          name="userName"
          label={intl.formatMessage({id: 'userName'})}
          rules={[{required: true}]}
          tooltip={{
            title: intl.formatMessage({id: 'userNameTooltip'}),
            icon: <InfoCircleOutlined />,
          }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="metricSystem"
          label={intl.formatMessage({id: 'metricSystem'})}
          tooltip={{
            title: intl.formatMessage({id: 'metricSystemTooltip'}),
            icon: <InfoCircleOutlined />,
          }}
        >
          <Select
            options={Object.keys(MetricSystemMetadata).map((key) => ({
              value: key,
              label: key,
            }))}
          ></Select>
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary" style={{marginRight: 15}}>
            {intl.formatMessage({id: 'save'})}
          </Button>

          <Button onClick={() => revalidator.revalidate()}>
            {intl.formatMessage({id: 'cancel'})}
          </Button>
        </Form.Item>
      </Form> */}
      <div style={{display: 'flex', flexDirection: 'column', width: 'min-content'}}>
        {isEmailSent ? (
          <div>{intl.formatMessage({id: 'checkYourEmail'})}</div>
        ) : (
          <Button
            style={{marginTop: '30px'}}
            onClick={async () => {
              userService.resetPassword(userSettings.email)
              setEmailSent(true)
            }}
          >
            {intl.formatMessage({id: 'changePassword'})}
          </Button>
        )}

        <Button style={{marginTop: '30px'}} danger onClick={showConfirm}>
          {intl.formatMessage({id: 'deleteAccount'})}
        </Button>
      </div>
    </div>
  )
}
